module.exports = __webpack_public_path__ + "media/images/user/disclaimers/basic_course-1f7fb5d56f2bd7041780ae8685656655.jpg";